import request from '@/api/request'

/**
 * 管理端获取考试列表
 */
export const getPlanItemList  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端添加考试
 */
export const addPlanItem  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/add',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端编辑考试
 */
export const updatePlanItem  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/update',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端删除考试
 */
export const removeTestPlanItem  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/del',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 分页查询考试计划列表(学员列表)
 */
export const getUserList  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 考试计划列表取消(学员列表)
 */
export const userTestPlanDel  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/del',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 分页查询考试计划列表
 */
export const getListUserTestPlanSubscribe  = (data) => {
  return request({
    url: 'product/adm/userTestPlanSubscribe/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 修改证件照片
 */
export const handleUpdateImg  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/updateImg',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 删除学员
 */
export const handleDelUser  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/delUser',
    method: 'post',
    type: 'json',
    data
  })
}

/**
* 导入实操能力考核成绩
*/
export const importUserPracticalScore = (data, testPlanId, type = 1) => {
  let url = `product/adm/userTestPlan/${testPlanId}/importUserPracticalScore`
  if (type === 1) {
    url = `product/adm/userTestPlan/${testPlanId}/importUserTheoryScore`
  }
  return request({
    url,
    method: 'post',
    upload: true,
    data
  })
}

/**
* 导入实操能力考核成绩
*/
export const getPracticalWorkListPage = (data, testPlanId) => {
  return request({
    url: 'product/adm/practicalInfo/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 修改实操能力考核成绩
 */
export const updateUserPracticalScore = (data) => {
  return request({
    url: 'product/adm/userTestPlan/updateUserPracticalScore',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 实操作业管理-判卷记录
 */
export const getGradingListPage = (data) => {
  return request({
    url: 'product/adm/practicalInfo/getGradingListPage',
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-作业记录
export const getExerciseRecordListPage = data => {
  return request({
    url: 'product/adm/practicalInfo/getExerciseRecordListPage',
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-获取成绩标准配置
export const getScoreConf = () => {
  return request({
    url: 'product/adm/practicalInfo/getScoreConf',
    method: 'get'
  })
}

// 实操作业管理-更新成绩标准配置
export const updateScoreConf = data => {
  return request({
    url: 'product/adm/practicalInfo/updateScoreConf',
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-获取作业类型配置
export const getExerciseConfList = () => {
  return request({
    url: 'product/adm/practicalInfo/getExerciseConfList',
    method: 'get'
  })
}

// 实操作业管理-更新作业类型配置
export const saveExerciseConf = data => {
  let url = 'product/adm/practicalInfo/saveExerciseConf'
  if (data.id) {
    url = 'product/adm/practicalInfo/updateExerciseConf'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-删除作业类型配置
export const delExerciseConf = data => {
  return request({
    url: 'product/adm/practicalInfo/delExerciseConf',
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-作业判卷
export const gradingPractical = data => {
  return request({
    url: 'product/adm/practicalInfo/grading',
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-发布成绩
export const publishGrading = data => {
  return request({
    url: 'product/adm/practicalInfo/publish',
    method: 'post',
    type: 'json',
    data
  })
}

// 实操作业管理-批量发布成绩
export const batchPublishGrading = data => {
  return request({
    url: 'product/adm/practicalInfo/batchPublish',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 根据手机号码查询用户信息
 */
export const geToAddUserInfo  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/geToAddUserInfo',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 补全添加学员信息
 */
export const handleAddUserInfo  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/add',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 添加记录查询
 */
export const listUserLogPage  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/listUserLogPage',
    method: 'post',
    type: 'json',
    data
  })
}
